// extracted by mini-css-extract-plugin
module.exports = {"arrow_next":"arrow_next-jagRA arrow_next-1RFeq","arrow_prev":"arrow_prev-2J-iA"};